<!-- <div class="modal-header justify-content-between d-flex pt-4">
  <h1 class="modal-title">{{ config.popupTitle || 'QR Code' }}</h1> 
</div> -->
<div class="modal-body">
  <app-qr-generation
    [data]="config.data"
    [options]="config.options || {}"
    [showDownload]="config.showDownload !== false"
    [showCopy]="true"
    [label]="config.label || ''"
    (qrGenerated)="onQrGenerated($event)"
    (qrError)="onQrError($event)"
  >
  </app-qr-generation>
</div>
<div class="modal-footer">
  <button type="button" (click)="closeDialog()" class="btn btn-danger btn-h42">Close</button>
</div>
